import React, { useEffect, useRef } from "react";

const COOKIE_CONSENT_KEY = "cookie_consent_accepted";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-9WN1RKWJQL";
const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || "vpnv6ktmt3";

/**
 * Loads Google Analytics (GA4), Facebook Pixel, and Microsoft Clarity (heatmaps)
 * only after cookie consent and when the respective env vars are set.
 */
function Analytics() {
  const initialized = useRef({ ga: false, fb: false, clarity: false });

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!accepted) return;

    if (GA_MEASUREMENT_ID && !initialized.current.ga) {
      initialized.current.ga = true;
      const s1 = document.createElement("script");
      s1.async = true;
      s1.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_MEASUREMENT_ID;
      document.head.appendChild(s1);
      window.dataLayer = window.dataLayer || [];
      function gtag(){ window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", GA_MEASUREMENT_ID, { send_page_view: true, anonymize_ip: true });
    }

    if (FB_PIXEL_ID && !initialized.current.fb) {
      initialized.current.fb = true;
      const fbp = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','" + FB_PIXEL_ID + "');fbq('track','PageView');";
      const s2 = document.createElement("script");
      s2.textContent = fbp;
      document.head.appendChild(s2);
    }

    if (CLARITY_PROJECT_ID && !initialized.current.clarity) {
      initialized.current.clarity = true;
      var c = window;
      c.clarity = c.clarity || function() { (c.clarity.q = c.clarity.q || []).push(arguments); };
      const s3 = document.createElement("script");
      s3.async = true;
      s3.src = "https://www.clarity.ms/tag/" + CLARITY_PROJECT_ID;
      document.head.appendChild(s3);
    }
  }, []);

  return null;
}

export default Analytics;
